import { ComponentsOverrides, Theme } from "@mui/material";

const MuiTable: ComponentsOverrides<Theme>["MuiTable"] = {
  root: {
    margin: "0px -6px",
  },
};

export default MuiTable;
